import { render, staticRenderFns } from "./LessonVocabulary.vue?vue&type=template&id=9cd7a7b6&scoped=true"
import script from "./LessonVocabulary.vue?vue&type=script&lang=js"
export * from "./LessonVocabulary.vue?vue&type=script&lang=js"
import style0 from "./LessonVocabulary.vue?vue&type=style&index=0&id=9cd7a7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd7a7b6",
  null
  
)

export default component.exports